module.exports = __webpack_public_path__ + "static/media/Digital_Privacy_Advisory.c10e2862.png";